import alasql from 'alasql'
import { alaSQLtableName } from '../load/alasql.js'
import { consolidationOrg } from './special-entities.js'

export function computeConsolidation (context) {
  // No consolidation needed if there is only one entity
  if (context.includedEntityIds.length === 1) return

  console.group('computeConsolidation()')

  console.log('computeConsolidation', context)

  // #1 Remove consolidation data
  alasql(`DELETE FROM ${alaSQLtableName} WHERE accounting_organisation_id = '${consolidationOrg.id}'`)
  console.log('deleted consolidation data')

  const quotedIncludedEntityIds = context.includedEntityIds.map(d => `'${d}'`).join(',')
  console.log('quotedIncludedEntityIds', quotedIncludedEntityIds)

  const valuesDB = alasql(`
    SELECT * 
    FROM ${alaSQLtableName} 
    WHERE accounting_organisation_id IN (${quotedIncludedEntityIds})
  `)
  console.log('computeConsolidation', valuesDB)

  // #5 Insert consolidation data
  console.time('insertConsolidationData')

  // const valuesToInsert = []
  valuesDB.forEach(function (value) {
    const newValue = Object.assign({}, value)
    newValue.accounting_organisation_id = consolidationOrg.id
    newValue.entity = consolidationOrg
    // valuesToInsert.push(newValue)

    alasql(`INSERT INTO ${alaSQLtableName} VALUES ?`, [newValue])
  })
  // alasql(`INSERT INTO ${alaSQLtableName} SELECT * FROM ?`, [valuesToInsert])
  // March 2nd 2025: seems no difference in performance between individual or batch insert
  console.timeEnd('insertConsolidationData')
  console.groupEnd()
}
